import { useEffect, useState, useCallback } from 'react';

import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { flushSync } from 'react-dom';

export function useFetchModal<T>(
  url: string,
  isOpen: boolean,
  params?: any
): {
  data: T | null;
  loading: boolean;
  error: Error | null;
} {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const makeRequest = useCallback(async () => {
    try {
      flushSync(() => setLoading(true));
      const response = await standardRequestWithErrorFlash.get(url, params);
      setData(response.data);
    } catch (e: any) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    makeRequest();
  }, [isOpen, url, makeRequest]);
  return { data, loading, error };
}
